var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditModeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6,34.5V42h7.5l22.1-22.1l-7.5-7.5C28.1,12.4,6,34.5,6,34.5z M41.4,14.1c0.8-0.8,0.8-2.1,0-2.8l-4.7-4.7 c-0.8-0.8-2-0.8-2.8,0l-3.7,3.7l7.5,7.5C37.7,17.8,41.4,14.1,41.4,14.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,0h48v48H0V0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditModeIcon);
export default __webpack_public_path__ + "static/media/edit_mode_icon.9338a8a198d9b103ab8295aa2fbda2ea.svg";
export { ForwardRef as ReactComponent };